import React, { FC, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import CaptionFont from '../../../Theme/Fonts/Caption'
import {
    Goal,
    PenaltyMissed,
    PenaltyScored,
    RedCard,
    SecondYellowCard,
    SubstitutionExchange,
    YellowCard,
} from '../HelperClass/Icons'
import { SummaryEventRowProps, EventIconTypes } from './Types'

const mapTypeToIcon = (iconType: EventIconTypes): ReactElement => {
    if (iconType === 'YELLOW_CARD') {
        return <YellowCard fontSize="FS12" />
    } else if (iconType === 'RED_CARD') {
        return <RedCard fontSize="FS12" />
    } else if (iconType === 'SECOND_YELLOW_CARD') {
        return <SecondYellowCard fontSize="FS12" />
    } else if (iconType === 'PENALTY_MISSED') {
        return <PenaltyMissed fontSize="FS10" />
    } else if (iconType === 'PENALTY_SCORED') {
        return <PenaltyScored fontSize="FS12" />
    } else if (iconType === 'SUBSTITUTION') {
        return <SubstitutionExchange fontSize={16} />
    } else if (iconType === 'GOAL') {
        return <Goal fontSize="FS12" />
    }
    return <FontelloIcon name={iconType} fontSize="FS12" color="onyx-4" />
}

const SummaryEventRow: FC<SummaryEventRowProps> = ({
    onPress,
    homeCompetitor,
    homeIconType,
    timeLabel,
    awayIconType,
    awayCompetitor,
    testID,
}) => {
    return (
        <Touchable testID={testID} onPress={onPress}>
            <Grid noExpand width="100%" horizontal backgroundColor="pearl" centerVertical>
                <Grid minWidth={0}>
                    {homeCompetitor && homeIconType ? (
                        <Grid horizontal alignRight centerVertical minWidth={0}>
                            <Grid minWidth={0}>
                                <CaptionFont color="onyx" textAlign="right" numberOfLines={1}>
                                    {homeCompetitor}
                                </CaptionFont>
                            </Grid>
                            <Grid noExpand center width={28}>
                                {mapTypeToIcon(homeIconType)}
                            </Grid>
                        </Grid>
                    ) : null}
                </Grid>
                <Grid
                    noExpand
                    width={40}
                    height={24}
                    marginX={2}
                    centerHorizontal
                    centerVertical
                    backgroundColor="tahitian-3"
                >
                    <CaptionFont color="keshi-3">{timeLabel}</CaptionFont>
                </Grid>
                <Grid minWidth={0}>
                    {awayIconType && awayCompetitor ? (
                        <Grid horizontal centerVertical minWidth={0}>
                            <Grid noExpand center width={28}>
                                {mapTypeToIcon(awayIconType)}
                            </Grid>
                            <Grid minWidth={0}>
                                <CaptionFont color="onyx" numberOfLines={1}>
                                    {awayCompetitor}
                                </CaptionFont>
                            </Grid>
                        </Grid>
                    ) : null}
                </Grid>
            </Grid>
        </Touchable>
    )
}

export default SummaryEventRow
